import React from 'react';
import Layout from '../components/layout/Layout';
import LabResultsForm from '../components/reports/LabResultsForm';

const LabResultsPage = () => {
  return (
    <Layout>
      <LabResultsForm />
    </Layout>
  );
};

export default LabResultsPage;
